export const MAX_DISPLAYED_NOTABLE_CLIENTS = 2;
